import { toast } from "sonner";

import { useRestApi } from "@/context/api";
import type { ExportFormat } from "@/context/api/RestApiContext";
import { useCurrentCompany } from "@/context/auth";
import { fileNameDate } from "@/lib/format";

export const useExportUsers = () => {
  const { exportUsers } = useRestApi().user;
  const currentCompany = useCurrentCompany();

  const downloadExport = async (format: ExportFormat = "TSV") => {
    try {
      const blob = await exportUsers(currentCompany.id, format);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `users-export-${fileNameDate()}.${format.toLowerCase()}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Users report downloaded");
    } catch {
      toast.error("Couldn't download the users report. Try again in a moment.");
    }
  };

  return { downloadExport };
};
